import React from "react"

// providers
import { trans } from "@/_providers/Translation"

// components
import BusyTechnicians from "./partials/BusyTechnicians"
import TechnicianInventory from "./partials/TechnicianInventory"

function Realtime() {
  return (
    <div id="analytics-realtime">
      <div className="top-part">
        <div className="left">
          <h1 className="page-heading">{trans("nav.analytics_realtime")}</h1>
          <p className="page-subheading">{trans("subheadings.analytics_realtime")}</p>
        </div>
      </div>

      <div className="row">
        <div className="col">
          <div className="pannel">
            <BusyTechnicians />
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col">
          <div className="pannel">
            <TechnicianInventory />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Realtime
